import { FC } from "react";

import Image from "@/components/ui/Image/Image";
import { EditorialModuleImage } from "@/types";

const TiledBlockV4: FC<{ items: EditorialModuleImage[] }> = ({ items }) => {
  return (
    <>
      <div className="grid grid-cols-1 h-full w-full">
        <div className="col-span-1 grid grid-cols-1">
          <Image src={items[0].image!.url} width={200} height={300} className="w-full h-full rounded-lg aspect-2-1" alt={items[0].image!.title} />
        </div>
      </div>
    </>
  );
};
export default TiledBlockV4;
